import { queryOptions } from '@tanstack/react-query'
import {
	getMapDeploymentsFromLocalStorage,
	saveToLocalStorage,
} from './localStorage'
import {
	type ServerReceivedMapDeployments,
	validateServerReceivedMapDeployments,
} from './models/mapDeployments'

export async function fetchMapDeployments() {
	try {
		// if set it will override the default URL for fetching map deployments
		const url =
			import.meta.env.VITE_ASSETS_MAP_DEPLOYMENTS_LOCAL_URL ||
			'https://d3bj8knxlstxyw.cloudfront.net/marketview-assets-map-deployments.json'

		const req = await fetch(url)
		if (req.ok) {
			const data =
				(await req.json()) as unknown as ServerReceivedMapDeployments

			// validate data before saving to local storage
			const validationResult = validateServerReceivedMapDeployments(data)
			if (validationResult.success) {
				saveToLocalStorage(data)
				return data
			}
			if (validationResult.isError) {
				// biome-ignore lint/suspicious/noConsole: we want to log errors here
				console.error(
					'error validating data from server'
					// validationResult.error
				)
				const localStorageData = getMapDeploymentsFromLocalStorage()
				if (localStorageData) {
					return localStorageData
				}
			}

			// if we get here, we dynamically import the local data file as a fallback
			const localDataModule = await import(
				/* @vite-ignore */ './data/initialMapDeployments.json'
			)
			const localData =
				localDataModule.default as unknown as ServerReceivedMapDeployments
			return localData

			// if we reach here something unexpected happened
			// tanstack query will handle the error
		} else {
			throw new Error(`Failed to fetch: ${req.status} ${req.statusText}`)
		}
	} catch (error) {
		if (error instanceof Error) {
			throw new Error(`unknown error fetching data: ${error.message}`)
		}
		throw new Error(`unknown error fetching data:${error}`)
	}
}

export const mapDeploymentsOptions = queryOptions({
	queryKey: ['mapDeployments'],
	queryFn: async () => fetchMapDeployments(),
	staleTime: 1000 * 60 * 60, // 1 hour
})
